const catalogsByKeys = [
    {
        keys: ['countryCode', 'nativeCountryCode'],
        name: 'countries',
        field: 'countryCode'
    },
    {
        keys: ['cityCode'],
        name: 'cities',
        field: 'cityCode'
    },
    {
        keys: ['zoneCode'],
        name: 'area-types',
        field: 'code'
    },
    {
        keys: ['sex'],
        name: 'genders',
        field: 'code'
    },
    {
        keys: ['attentionMode'],
        name: 'attention-type',
        field: 'code'
    },
    {
        keys: ['purposeCode'],
        name: 'consultation-purposes',
        field: 'code'
    },
    {
        keys: ['attentionCauseCode'],
        name: 'external-causes',
        field: 'code'
    },
    {
        keys: ['identificationTypeCode'],
        name: 'document_type',
        field: 'code'
    },
    {
        keys: ['userType'],
        name: 'user-types',
        field: 'code'
    },
    {
        keys: ['serviceGroupCode'],
        name: 'service-group',
        field: 'code'
    },
    {
        keys: ['serviceCode'],
        name: 'care-unit',
        field: 'code'
    },
    {
        keys: ['paymentMode'],
        name: 'payment-modalities',
        field: 'code'
    },
    {
        keys: ['benefitPlan'],
        name: 'coverage-plans',
        field: 'code'
    },
    {
        keys: ['principalDiagnosisTypeCode'],
        name: 'primary-diagnosis-types',
        field: 'code'
    },
    {
        keys: ['biologicalSex'],
        name: 'genders',
        field: 'alternateCode'
    },
    {
        keys: ['revenueConceptCode', 'serviceEntryMode'],
        name: 'billing-concept',
        field: 'code'
    },
    {
        keys: ['serviceEntryMode'],
        name: 'hospital-admission-type',
        service: 'hospitalization',
        field: 'code'
    },
    {
        keys: ['dischargeConditionAndDestinationCode'],
        name: 'user-discharge-condition',
        field: 'code'
    },
    {
        keys: ['drugType'],
        name: 'medication-type-pos',
        field: 'code'
    },
    {
        keys: ['unitOfMeasure'],
        name: 'measurement-units',
        field: 'code'
    },
    {
        keys: ['dosageForm'],
        name: 'pharmaceutical-forms',
        field: 'code'
    },
    {
        keys: ['minimumUnitDispensed'],
        name: 'dispensing-units',
        field: 'code'
    },
    {
        keys: ['otherServiceType'],
        name: 'other-service-type',
        field: 'code'
    },
    {
        keys: ['noteType'],
        name: 'note-type',
        field: 'code'
    }
]


export {
    catalogsByKeys
}